// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { withTranslator } from '@gandi/translate';

import { fetchCorporatePackMonthlyPrices } from '../modules/app/actions';

import type { FullState, Dispatch } from '../types';

import Presenter from './Presenter';
import type { DomainCreateDispatchProps } from './Presenter';
import { fetchIDNAvailableLanguages } from './modules/actions/idn';
import { reset as resetResults } from './modules/actions/results';
import { reset as resetSearch } from './modules/actions/search';

import {
  selectHasCorporateTLDs,
  selectHasIDNResults,
} from './modules/selectors/results';

const mapDispatchToProps = (dispatch: Dispatch): DomainCreateDispatchProps => ({
  fetchIDNAvailableLanguages: (...args: any) =>
    dispatch(fetchIDNAvailableLanguages(...args)),
  fetchCorporatePackMonthlyPrices: (...args: any) =>
    dispatch(fetchCorporatePackMonthlyPrices(...args)),
  // $FlowFixMe[not-an-array]
  resetResults: () => dispatch(resetResults()),
  // $FlowFixMe[not-an-array]
  resetSearch: () => dispatch(resetSearch()),
});

const mapStateToProps = (state: FullState) => ({
  hasCorporateTLDs: selectHasCorporateTLDs(state),
  hasIDNResults: selectHasIDNResults(state),
});

export default (compose(
  withPageMeta(args => ({
    title: args.__('Domain name registration - Gandi.net'),
    description: args.__(
      'Domain names - One of the largest catalogs of new TLDs, with free mailboxes and SSL certificate.',
    ),
  })),
  withTranslator({ propsNamespace: 'translator' }),
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{}>);
